import React from 'react'
import EmptyStateSvg from 'assets/images/watermarking-playlists-empty-state.svg'
import { PLAYLIST } from '@disco/constants/ItemTypes'
import Header from 'components/ui/heading'
import styles from './index.module.css'

const WatermarkingEmptyState = ({
  type,
}: {
  type: string
}): React.ReactElement<'div'> => {
  let description = 'Please try another search term'

  if (type === PLAYLIST) {
    description =
      'Please try another search term or add watermarking to a playlist above'
  }

  return (
    <div className={styles.watermarkingEmptyState}>
      <EmptyStateSvg className={styles.watermarkingEmptyStateSvg} />

      <Header>No results for this search</Header>
      <p className={styles.watermarkingEmptyStateDescription}>{description}</p>
    </div>
  )
}

export default WatermarkingEmptyState
